import { gql } from 'apollo-boost';

export const PROBE_URL_DIRECT_DOWNLOADABILITY = gql`
    mutation($data: DownloadUrlInfoDumpInput!) {
        probeUrlDirectDownloadability(data: $data) {
            url
            name
            displayName
            type
            format
            size
            mime
        }
    }
`;
